<template>
  <div class="edit-form">
    <Card class="form-card">
      <h2 slot="title">编辑申请</h2>

      <div class="apply">
        <h3>请假/调休</h3>
        <div>
          <i-form label-position="left" :label-width="120" class="default-form">
            <div class="new-form-group">
              <FormItem label="请假类型" class="new-default-form-item" required>
                <Row>
                  <i-col span="16">
                    <RadioGroup :value="formValue.vacationType" size="large" @on-change="changeType">
                      <Radio v-for="n in 4" :key="n" :label="vacaConf.type[n - 1].id" class="new-default-form-radio"
                        style="width: 25%;height:40px">{{ vacaConf.type[n - 1].label }}</Radio>
                    </RadioGroup>
                  </i-col>
                  <i-col span="8">
                    <!-- <Select  :value="formValue.vacationType" placeholder="请选择其他类型假期"
                      @on-change="changeType" filterable>
                      <Option v-for="n in 6"  :value="vacaConf.type[n + 3].id"
                        :key="n + 3">{{ vacaConf.type[n + 3].label }}</Option>
                    </Select> -->
                    <Select transfer size="large" :value="formValue.vacationType" placeholder="请选择其他类型假期"
                      @on-change="changeType" filterable>
                      <Option v-for="n in 9" :disabled="vacaConf.type[n + 3].disabled" :value="vacaConf.type[n + 3].id"
                        :key="n + 3">{{ vacaConf.type[n + 3].label }}</Option>
                    </Select>
                  </i-col>
                </Row>
              </FormItem>
              <Row v-show="formValue.vacationType == 4">
                <i-col span="24" class="default-form-member-col">
                  <FormItem label="可用调休时间" class="new-default-form-item happen-date" required>
                    <DatePicker ref="datepick" :options="happenDateOpt['default']" multiple
                      class="new-deadline deadline" type="datetime" placeholder="请先选择可用调休时间（必填）" format="yyyy-MM-dd"
                      :value="formValue.relationDateList" @on-change="happenDateChange($event)" :clearable="false"
                      :editable="false"></DatePicker>
                  </FormItem>
                </i-col>
              </Row>
              <Row>
                <i-col span="12" class="default-form-member-col">
                <FormItem label="请假开始时间" class="new-default-form-item" required>
                    <el-date-picker
                    :style=valueTime1Style()
                    class="new-deadline deadline"
                    v-model="startTime"
                    type="date"
                    :clearable=false
                    :editable=false
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="disabTimeStart"
                    @change="TimeChange()"
                    placeholder="选择请假开始时间（必填）">
                  </el-date-picker>
                  <el-select placeholder="请选择" v-if="startTime" v-model="valueTime1" @change="TimeChange(options)" style="width: calc(100% - 150px);border: none;">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </FormItem>
                <!-- <FormItem label="请假开始时间" class="new-default-form-item" required>
                  <DatePicker :options="vacaDateOpt['default']" split-panels :value="vacaDays" transfer
                    class="new-deadline deadline" type="datetimerange" format="yyyy-MM-dd HH:mm"
                    placeholder="选择请假开始时间（必填）" :clearable="false" :editable="false" @on-change="selectDate"></DatePicker>
                </FormItem> -->
              </i-col>
              <i-col span="12" class="default-form-member-col">
                <FormItem label="请假结束时间" class="new-default-form-item" required>
                    <el-date-picker
                    :style=valueTime2Style()
                    class="new-deadline deadline"
                    v-model="endTime"
                    type="date"
                    :clearable=false
                    :editable=false
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    @change="TimeChange()"
                    :picker-options="disabTime"
                    placeholder="选择请假结束时间（必填）">
                  </el-date-picker>
                  <el-select v-if="endTime" placeholder="请选择" v-model="valueTime2" @change="TimeChange()" style="width: calc(100% - 150px);border: none;">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :disabled="item.disabled"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </FormItem>
              </i-col>
                <!-- <i-col span="24" class="default-form-member-col">
                  <FormItem label="请假时间" class="new-default-form-item" required>
                    <DatePicker :options="vacaDateOpt['default']" split-panels :value="vacaDays" transfer
                      class="new-deadline deadline" type="datetimerange" format="yyyy-MM-dd HH:mm"
                      placeholder="选择请假时间（必填）" :clearable="false" :editable="false" @on-change="selectDate">
                    </DatePicker>
                  </FormItem>
                </i-col> -->
              </Row>
              <Row>
                <i-col span="24" class="default-form-member-col">
                  <FormItem label="请假天数" class="new-default-form-item" required>
                    <i-input :value="formValue.dayCountE2" readonly></i-input>
                  </FormItem>
                </i-col>
              </Row>
              <Row>
                <i-col span="24" class="default-form-member-col">
                  <FormItem label="请假理由" class="new-default-form-item" required>
                    <i-input type="textarea" v-model="formValue.reason" placeholder="请在此填写请假理由"></i-input>
                  </FormItem>
                </i-col>
              </Row>
            </div>
          </i-form>
        </div>
      </div>
      <div class="g-ta-r">
        <Button type="primary" class="submit-btn form-default-btn" size="large" @click.native="submit"
          :loading="submitBtn">确认修改</Button>
      </div>
      <loading v-if="isLoading"></loading>
      <toast :is-toast="isToast" :msg="toastMsg"></toast>
    </Card>
  </div>
</template>

<script>
import {
  Schedule
} from "../../API/api";
import Loading from "../../components/popup/Loading";
import Toast from "../../components/popup/Toast";
import {
  type
} from "os";
export default {
  components: {
    Toast,
    Loading
  },
  name: "apply",
  data() {
    return {
      options: [{
          value: '1',
          label: '上午',
          disabled: false
        }, {
          value: '2',
          label: '下午',
          disabled: false
        }],
      valueTime1: '1',
      valueTime2: '2',
      startTime:'',
      endTime:'',
      disabTime:null,
      disabTimeStart:null,
      submitBtn: false,
      showTips: false,
      canSubmit: true,
      toastMsg: null,
      isToast: false,
      isLoading: false,
      allVaca: {},
      vacaDays: null,
      happenDateObj: {},
      selectHappenDays: 0,
      toastMsgConf: {
        vacationType: "请选择请假类型",
        startTime: "请选择请假开始时间",
        endTime: "请选择请假结束时间",
        dayCountE2: "请选择请假时间",
        reason: "请输入请假理由"
      },
      formValue: {
        vacationType: null,
        relationDateList: [],
        startTime: null,
        endTime: null,
        dayCountE2: null,
        reason: null
      },
      happenDateOpt: {
        default: {}
      },
      vacaDateOpt: {
        default: {
          disabledDate(date) {
            return false
            // return date && date.valueOf() < Date.now() - 86400000;//请假不能选择今天之前的
          }
        }
      },
      vacaConf: {
        type: [{
          id: "1",
          label: "事假"
        },
        {
          id: "2",
          label: "病假(带薪)",
          checkPermission: true
        },
        {
          id: "10",
          label: "病假(普通)"
        },
        {
          id: "3",
          label: "年假",
          checkPermission: true
        },
        {
          id: "4",
          label: "调休",
          disabled: false,
        },
        {
          id: "6",
          label: "婚假",
          disabled: false,
        },
        {
          id: "7",
          label: "丧假",
          disabled: false,
        },
        {
          id: "8",
          label: "产假",
          disabled: false,
        },
        {
          id: "9",
          label: "陪产假",
          disabled: false,
        },

        {
          id: "11",
          label: "公司福利假",
          disabled: false,
        },
        {
          id: "12",
          label: "产检假",
          disabled: false,
        },
        {
          id: "13",
          label: "征兵体检假",
          disabled: false,
        },
        {
          id: "5",
          label: "其他",
          disabled: false,
        }
        ]
      },
      start_time_old: '',
      oldType: null,
    };
  },
  methods: {
    valueTime1Style(){
        let obj = {
          width: this.startTime ? '150px' : '100%',
          border:'none',
        }
        return obj
      },
      valueTime2Style(){
        let obj = {
          width: this.endTime ? '150px' : '100%',
          border:'none',
        }
        return obj
      },
    getDetail() {
      this.isLoading = true
      this.$http.post(Schedule.vacaDetail, this.qs.stringify({
        id: this.$route.params.applyId
      }), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      }).then((res) => {
        this.isLoading = false
        let _data = res.data
        if (_data.retCode === 0) {
          this.formValue = _data.retData
          this.start_time_old = this.formValue.startTime
          this.startTime = this.formValue.startTime.split(' ')[0]
          this.endTime = this.formValue.endTime.split(' ')[0]
          if(this.formValue.startTime.split(' ')[1].split(':')[0] == '09'){
            this.valueTime1 = "1";
          } else if(this.formValue.startTime.split(' ')[1].split(':')[0] == 14){
            this.valueTime1 = "2";
          } else if(this.formValue.startTime.split(' ')[1].split(':')[0] == 18){
            this.valueTime1 = "2";
          }
          if(this.formValue.endTime.split(' ')[1].split(':')[0] == '09'){
            this.valueTime2 = "1";
          } else if(this.formValue.endTime.split(' ')[1].split(':')[0] == 14){
            this.valueTime2 = "1";
          } else if(this.formValue.endTime.split(' ')[1].split(':')[0] == 18){
            this.valueTime2 = "2";
          }
          this.vacaDays = [this.formValue.startTime, this.formValue.endTime]
          this.formValue.vacationType = String(this.formValue.vacationType)
          setTimeout(() => {
            this.formValue.relationDateList = this.formValue.relationDateList == '' ? '' : JSON.parse(this.formValue
              .relationDateList)
            if (_data.retData.vacationName == '调休') {
              console.log(this.formValue.relationDateList)
              this.happenDateChange(this.formValue.relationDateList.join())
            }
          }, 2000)



          // this.oldType=_data.retData.vacationType;
          let self = this
          console.log(_data.retData.vacationType, '_data.retData.vacationName', self.formValue.startTime, '=====')
          if (_data.retData.vacationType != 2 && _data.retData.vacationType != 10) {
            self.vacaDateOpt = {
              default: {
                disabledDate(date) {
                  return false;
                  // return date && date.valueOf() < new Date(self.formValue.startTime).valueOf() - 1 * 24 * 60 *
                  //   60 * 1000
                },
              }
            };
          }
        } else {
          this.isToast = true
          this.toastMsg = _data.retMsg
        }
        setTimeout(() => {
          this.isToast = false
          this.toastMsg = null
          this.toastState = null
          if (_data.retCode === 100014) {
            this.$cookie.delete('token')

            this.$router.push('/')
          }
        }, 1500)
      })
    },

    /* 获取所选发生时间的第二天 */
    nextDay(startDate) {
      startDate = new Date(startDate.replace(/-/g, '/'));
      startDate = +startDate + 1000 * 60 * 60 * 24;
      startDate = new Date(startDate);
      let year = startDate.getFullYear();
      let month = startDate.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = startDate.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      var nextStartDate = `${year}-${month}-${day}`;
      return nextStartDate;
    },
    happenDateChange(date) {
      this.startTime="";
        this.endTime="";
      let chooseDate = date.split(',')
      chooseDate = new Date(chooseDate.slice(chooseDate.length - 1).join(',')).getTime()
      let startVacaDays
      if (!!this.vacaDays) {
        startVacaDays = new Date(this.vacaDays[0].slice(0, 10)).getTime()
        if (chooseDate >= startVacaDays) {
          console.log('调休时间比请假时间大')
          this.vacaDays = null;
          this.formValue.dayCountE2 = null
        }
      }
      this.formValue.relationDateList = date.length ? date.split(",") : [];
      let dateArr = date.length ? date.split(",") : [];
      let selectDate;
      let nextDateArr = [];
      if (!dateArr.length) {
        //未选择发生时间，可选发生时间重置
        let happenDate = JSON.parse(JSON.stringify(this.happenDateObj));
        this.selectDate(this.vacaDays);
        this.happenDateOpt["default"] = {
          disabledDate(date) {
            let _year = date.getFullYear();
            let _month = date.getMonth() + 1;
            if (_month < 10) {
              _month = `0${_month}`;
            }
            let _day = date.getDate();
            if (_day < 10) {
              _day = `0${_day}`;
            }
            let _d = `${_year}-${_month}-${_day}`;
            let keyArr = happenDate.map(v => v.attendanceDate);
            return keyArr.indexOf(_d) < 0;
          }
        };
        //为选择发生时间，可选请假时间清零
        this.vacaDateOpt["default"] = {
          disabledDate(date) {
            return true;
          }
        };
      }
      dateArr.forEach(ele => {
        selectDate = new Date(ele.replace(/-/g, '/'));
        if (selectDate.getDay() < 5 && selectDate.getDay() > 0) {
          /* 当所选发生时间为周一到周四，发生时间为单选 */
          this.disabTimeStart = {
              disabledDate:(time) => {
                return time.getTime() < new Date(ele).getTime()|| time.getTime() > new Date(ele).getTime()+8.64e7
              }
            }
            this.disabTime = {
              disabledDate:(time) => {
                return time.getTime() < new Date(ele).getTime()|| time.getTime() > new Date(ele).getTime()+8.64e7// 如果没有后面的-8.64e7就是不可以选择今天的
              }
            }
          this.happenDateOpt["default"] = {
            disabledDate(date) {
              let _year = date.getFullYear();
              let _month = date.getMonth() + 1;
              if (_month < 10) {
                _month = `0${_month}`;
              }
              let _day = date.getDate();
              if (_day < 10) {
                _day = `0${_day}`;
              }
              let _d = `${_year}-${_month}-${_day}`;
              return ele !== _d;
            }
          };
          /* 当所选发生时间为周一到周四，请假时间只能选发生时间的第二天 */
          nextDateArr.push(this.nextDay(ele));
          this.vacaDateOpt["default"] = {
            disabledDate(date) {
              let _year = date.getFullYear();
              let _month = date.getMonth() + 1;
              if (_month < 10) {
                _month = `0${_month}`;
              }
              let _day = date.getDate();
              if (_day < 10) {
                _day = `0${_day}`;
              }
              let _d = `${_year}-${_month}-${_day}`;
              return nextDateArr.indexOf(_d) < 0;
            }
          };
        } else if (
          selectDate.getDay() === 0 ||
          selectDate.getDay() === 5 ||
          selectDate.getDay() === 6
        ) {
          var today = new Date(ele) //当天
            const TreeMou =  today.setMonth(today.getMonth()+3)//三个月后，时间戳
            const treeMoutn = today.toLocaleDateString().replace(/\//g, '-');
            this.disabTimeStart = {
              disabledDate:(time) => {
                return time.getTime() < new Date(ele).getTime() || time.getTime() > TreeMou;
              }
            }
            this.disabTime = {
              disabledDate:(time) => {
                return time.getTime() < new Date(ele).getTime() || time.getTime() > TreeMou;
              }
            }
          /* 当所选时间为周五、六、日时，周一到周四不可选 */
          let happenDate = JSON.parse(JSON.stringify(this.happenDateObj));
          this.happenDateOpt["default"] = {
            disabledDate(date) {
              let disableOneToFour = false;
              if (0 < date.getDay() && date.getDay() < 5) {
                disableOneToFour = true;
              }
              let _year = date.getFullYear();
              let _month = date.getMonth() + 1;
              if (_month < 10) {
                _month = `0${_month}`;
              }
              let _day = date.getDate();
              if (_day < 10) {
                _day = `0${_day}`;
              }
              let _d = `${_year}-${_month}-${_day}`;
              let keyArr = happenDate.map(v => v.attendanceDate);
              return keyArr.indexOf(_d) < 0 || disableOneToFour;
            }
          };

          this.vacaDateOpt["default"] = {
            disabledDate(date) {
              let start_time = new Date(selectDate);
              // timeObj.setMonth(timeObj.getMonth() + 3);
              // let end_time = timeObj.toString();
              let disable = true;
              if (
                start_time.getTime() < date.getTime()
              ) {
                disable = false;
              }
              return disable;
            }
          };

        }
      });
    },
    changeType(e) {
      this.startTime="";
        this.endTime="";
        this.formValue.dayCountE2 = null;
        this.disabTimeStart = {
              disabledDate:(time) => {
                return time.getTime() < time.getTime()
              }
            }
        this.disabTime  = {
              disabledDate:(time) => {
                return time.getTime() < time.getTime()
              }
            };
      if ((this.oldType == 2 || this.oldType == 10) && (e !== 2 || e != 10)) {
        this.vacaDays = null;
        this.oldType = null;
      }
      if (e) {
        this.formValue.vacationType = e;
        this.selectHappenDays = 0
        if (e == 4) {
          let happenDate = JSON.parse(JSON.stringify(this.happenDateObj));
          console.log(this.vacaDays, 'days');
          this.selectDate(this.vacaDays);

          // this.happenDateOpt["default"] = {
          //   disabledDate(date) {
          //     let _year = date.getFullYear();
          //     let _month = date.getMonth() + 1;
          //     if (_month < 10) {
          //       _month = `0${_month}`;
          //     }
          //     let _day = date.getDate();
          //     if (_day < 10) {
          //       _day = `0${_day}`;
          //     }
          //     let _d = `${_year}-${_month}-${_day}`;
          //     let keyArr = happenDate.map(v => v.attendanceDate);
          //     return keyArr.indexOf(_d) < 0;
          //   }
          // };
          //未选择发生时间，可选请假时间清零
          // this.vacaDateOpt["default"] = {
          //   disabledDate(date) {
          //     return true;
          //   }
          // };
        } else if (e == 2 || e == 10) {
          this.oldType = e;
          this.formValue.relationDateList = [];
          this.vacaDateOpt["default"] = {
            disabledDate(date) {
              return false;
            }
          };
        } else {

          this.formValue.relationDateList = [];
          let self = this;
          this.vacaDateOpt = {
            default: {
              disabledDate(date) {
                return false;
                // return date && date.valueOf() < new Date(self.start_time_old).valueOf() - 1 * 24 * 60 * 60 * 1000
              },
            }
          };
        }
        // else {
        //   this.formValue.relationDateList = [];
        //   this.vacaDateOpt["default"] = {
        //     disabledDate(date) {
        //       return false;
        //     }
        //   };
        // }
      }
    },
       // 计算请假天数
       countDay(){
        let st1 = new Date(this.startTime);
        let st2 = new Date(this.endTime);
        let days = st2.getTime() - st1.getTime();
        let day = parseInt(days/(1000 * 3600 * 24));
        console.log(this.startTime,this.endTime,'day-----')
        if(st1.getTime() != st2.getTime() && day == 1 && this.valueTime1 == 2 && this.valueTime2 == 1){
          day = day + 0;
        }else if(st1.getTime() != st2.getTime() && this.valueTime1 == 2 && this.valueTime2 == 1){
          day = day + 0
        }
        else if(st1.getTime() == st2.getTime() && this.valueTime1 == 1 && this.valueTime2 == 2){
          day = day + 1;
        }
        else if(st1.getTime() == st2.getTime()  ||
        (this.valueTime1 == 2 && this.valueTime2 == 2) || 
        (this.valueTime1 == 1 && this.valueTime2 == 1)){
          day = day + 0.5;
        } else if((this.valueTime1 == 1 && this.valueTime2 == 2) || (this.valueTime1 == 2 && this.valueTime2 == 1)) {
          day = day + 1;
        }
        if(this.endTime){
          this.formValue['dayCountE2'] = day
        }
      },
      // 禁用日期 可以选今天日期
      disDate(){
        let st1 = new Date(this.startTime);
        if(this.formValue.vacationType != "4"){
          this.disabTime = {
          disabledDate:(time) => {
            return time.getTime() < st1.getTime() - 8.64e7 ;
          }
        }
        } else if(this.formValue.vacationType == "4" && !this.formValue.relationDateList.length){
          this.disabTime = {
          disabledDate:(time) => {
            return time.getTime() < st1.getTime() - 8.64e7 ;
          }
        }}
        if(this.startTime && this.endTime){
            this.countDay();
        }
      },
      startEnd(){
        // 开始时间大于结束时间
        let st1 = new Date(this.startTime);
        let st2 = new Date(this.endTime);
        if(st1.getTime() > st2.getTime()) {
          this.endTime = this.startTime;
          if(this.formValue.vacationType != "4"){
            this.disDate();
          }
        }
      },
    TimeChange(e){
        // 同一天修改开始时间下午结束时间不可以是上午 feat
        if(e){
          if(this.valueTime1 == 2 && this.startTime == this.endTime){
            this.options[0]['disabled'] = true;
            this.valueTime2 = "2";
          } else if(Number(this.valueTime1,this.valueTime2) == 1) {
            this.options[0]['disabled'] = false;
          }
        } else {
          if(this.startTime == this.endTime){
            if(this.valueTime1 == 2) {
              this.valueTime2 = "2";
            }
          } else {
            this.options[0]['disabled'] = false;
          }
        }
        this.disDate();
        this.startEnd();
                        // 开始
                        if(this.startTime && this.endTime){
            if(this.valueTime1 == 1 && this.valueTime2 == 2){
              // 一天
              this.formValue['startTime'] = `${this.startTime} 9:00`;
              this.formValue['endTime'] = `${this.endTime} 18:30`;
            } else if(this.valueTime1 == 2 && this.valueTime2 == 2){
              // 下午
              this.formValue['startTime'] = `${this.startTime} 14:30`;
              this.formValue['endTime'] = `${this.endTime} 18:30`;
            }else if(this.valueTime1 == 2 && this.valueTime2 == 1){
              // 前一天下午到第二天上午
              this.formValue['startTime'] = `${this.startTime} 14:30`;
              this.formValue['endTime'] = `${this.endTime} 14:30`;
            } else {
              // 上午
              this.formValue['startTime'] = `${this.startTime} 9:00`;
              this.formValue['endTime'] = `${this.endTime} 14:30`;
            }
          } else {
            return
          }
      // console.log(this.formValue['startTime'],this.formValue['endTime'],'---------3')
    },
    submit() {
      for (let prop in this.formValue) {
        if (prop == 'vacationType' || prop == 'startTime' || prop == 'endTime' || prop == 'dayCountE2' || prop ==
          'reason') {
          if (!this.formValue[prop]) {
            this.toastMsg = this.toastMsgConf[prop];
            this.isToast = true;
            this.canSubmit = false;
            setTimeout(() => {
              this.canSubmit = true;
              this.isToast = false;
              this.toastMsg = null;
            }, 1500);
          }
        }
      }
      if (this.formValue.vacationType == "4") {
        if (!this.formValue.relationDateList.length) {
          this.canSubmit = false;
          this.toastMsg = "请选择调休发生时间";
          this.isToast = true;
          setTimeout(() => {
            this.canSubmit = true;
            this.isToast = false;
            this.toastMsg = null;
          }, 1500);
        } else {

          if (this.selectHappenDays < Number(this.formValue.dayCountE2)) {
            this.canSubmit = false;
            this.toastMsg = "请假天数不能大于调休天数";
            this.isToast = true;
            setTimeout(() => {
              this.canSubmit = true;
              this.isToast = false;
              this.toastMsg = null;
            }, 1500);
          }
          // else if(this.selectHappenDays != Number(this.formValue.dayCountE2)){
          //    this.canSubmit = false;
          //   this.toastMsg = "请假天数要和调休天数一样";
          //   this.isToast = true;
          //   setTimeout(() => {
          //     this.canSubmit = true;
          //     this.isToast = false;
          //     this.toastMsg = null;
          //   }, 1500);
          // }
        }
      } else {
        this.formValue.relationDateList = [];
      }
      if (this.canSubmit)  {
              this.submitBtn = true;
             this.$http
          .post(Schedule.editVaca, this.qs.stringify(this.formValue), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          })
          .then(res => {
            let _data = res.data;
            this.isLoading = false;
            this.isToast = true;
            this.submitBtn = false;
            if (_data.retCode === 0) {
              this.toastMsg = "修改成功";

            } else {
              this.toastMsg = _data.retMsg;
            }
            setTimeout(() => {
              this.isToast = false;
              this.toastMsg = null;
              if (_data.retCode === 0) {
                this.$router.push("/vacation/audit");
              } else if (_data.retCode === 100014) {
                this.$cookie.delete("token");

                this.$router.push("/");
              }
            }, 1500);
          })
          .catch(error=>{
            this.submitBtn = false;
          })
        //   } else {
        //         this.isToast = true;
        //   this.toastMsg = "开始时间和结束时间只能选择10、14、19(小时)";
        //   setTimeout(() => {
        //     this.isToast = false;
        //   }, 1500);
        //   }
        // } else {
        //   this.isToast = true;
        //   this.toastMsg = "开始时间和结束时间只能选择10、14、19(小时)";
        //   setTimeout(() => {
        //     this.isToast = false;
        //   }, 1500);
        // }
       
      }
    },
    selectDate(dateArr) {
      console.log(dateArr, 'dateArr')
      if (dateArr && dateArr[0]) {
        let start = dateArr[0];
        let end = dateArr[1];
        if (start.indexOf("00:00") >= 0) {
          console.log(start, '上海吗')
          // start = start.replace("00:00", "10:00");
          start = start.replace("00:00", "00:00");
          console.log(start, start.replace("00:00", "10:00"), '下面')
        }
        if (end.indexOf("00:00") >= 0) {
          //  end = end.replace("00:00", "19:00");
          end = end.replace("00:00", "00:00");
        }
        let startHour = +start.split(" ")[1].split(":")[0];
        let endHour = +end.split(" ")[1].split(":")[0];
        this.formValue.startTime = start;
        this.formValue.endTime = end;
        console.log(this.formValue.startTime, start)
        let startStamp = new Date(start.replace(/-/g, '/')).valueOf();
        let endStamp = new Date(end.replace(/-/g, '/')).valueOf();
        let diffStamp = endStamp - startStamp;
        let diffDays = Math.floor(diffStamp / 86400000);
        let diffHalfDay = 0;
        if (startHour < 14) {
          if (endHour <= 10) {
            diffHalfDay = 0;
          } else if (endHour <= 14) {
            diffHalfDay = 0.5;
          } else {
            diffHalfDay = 1;
          }
        } else if (startHour >= 14) {
          if (endHour > 14) {
            diffHalfDay = 0.5;
          } else {
            diffHalfDay = 1;
          }
        }
        this.formValue.dayCountE2 = diffDays + diffHalfDay;
        this.vacaDays = [start, end];
      } else {
        console.log('1234567')
        this.formValue.dayCountE2 = null;
        this.vacaDays = null;
      }
    },
    getVaca() {
      this.isLoading = true;
      this.$http
        .post(Schedule.vacaDays, this.qs.stringify({}), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          let _data = res.data;
          this.isLoading = false;
          if (_data.retCode === 0) {
            let originVaca = _data.retData.days;
            let vaca = [];
            originVaca.forEach(ele => {
              if (ele.name !== "其他") {
                vaca.push(ele);
              }
              if (ele.name === "公司福利假" && !ele.free > 0) {
                console.log('====公司福利假为0')
                this.vacaConf.type[9].disabled = true;
              }
            });
            this.allVaca = vaca;
          } else {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
    getHappenTime() {
      this.$http
        .post(Schedule.holidayHour, this.qs.stringify({ isEdit: true }), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          const _data = res.data;

          if (_data.retCode === 0) {
            let happenDate = _data.retData;
            this.happenDateObj = _data.retData;
            this.happenDateOpt["default"] = {
              disabledDate(date) {
                let _year = date.getFullYear();
                let _month = date.getMonth() + 1;
                if (_month < 10) {
                  _month = "0" + _month;
                }
                let _day = date.getDate();
                if (_day < 10) {
                  _day = "0" + _day;
                }
                let _d = `${_year}-${_month}-${_day}`;
                let keyArr = happenDate.map(v => v.attendanceDate);
                return keyArr.indexOf(_d) < 0;
              },
            };
          }
        });
    }
  },
  created() {
    this.getHappenTime();
    this.getVaca();
    this.getDetail()
  },
  watch: {
    "formValue.relationDateList": {
      handler(val) {
        const datepick = this.$refs.datepick.$el.getElementsByClassName(
          "ivu-picker-confirm-time"
        )[0];
        let days = 0;
        let hours = 0;
        let decimal = 0
        console.log(this.happenDateObj, 'this.happenDateObj')
        if (val && val.length) {
          this.happenDateObj.forEach(i => {
            if (val.indexOf(i.attendanceDate) !== -1) {
              if (Number(i.dayNum)) days += Number(i.dayNum)
              else {
                hours += Number(i.hourNum)
                if (hours > 4 || hours == 4) {
                  decimal = 0.5
                }
              }
            }

          })
          this.selectHappenDays = days + decimal
          datepick.innerHTML = `当前可调休：<big style="color:#2d8cf0">${days + decimal}</big>天`;
        } else {
          datepick.innerHTML = "";
        }
      },
      deep: true
    }
  }
};

</script>
<style scoped lang="less">
    /deep/ .el-input--suffix .el-input__inner{
      border: none !important;
    }
  .edit-form {
  .form-card {
    &:hover {
      box-shadow: 0 0 0;
    }

    .ivu-card-head {
      background-color: #f8f9fa;
      padding-left: 24px;
      padding-right: 24px;

      h2 {
        font-size: 14px;
        color: #343a40;
      }
    }

    .ivu-card-body {
      padding: 32px;
    }
  }
}

.default-form .default-form-radio-group .default-form-radio:nth-child(3n) {
  border-right: 1px solid #ced4da;
}

.used-vaca-table {
  margin-bottom: 32px;
  border-bottom: 1px solid #ced4da;
  padding-bottom: 32px;

  h3 {
    margin-bottom: 16px;
  }
}

.used-vaca {
  width: 100%;
  border: 1px solid #ced4da;
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #ced4da;
    text-align: center;
    font-weight: normal;
    height: 40px;
  }

  th {
    background-color: #fff9db;
  }
}
</style>
